import React from 'react';
import { Zoom } from 'react-reveal';
import styled from 'styled-components';

import { Flex, Text } from '../../../components';

import Yeezysupply from '../../../assets/Sitelist/Yeezysupply.png';
import Walmart from '../../../assets/Sitelist/Walmart.png';
import Shopify from '../../../assets/Sitelist/Shopify.svg';


const sites = [
  { icon: Yeezysupply, name: 'Yeezysupply' },
  { icon: Shopify, name: 'Shopify' },
  { icon: Walmart, name: 'Walmart' }
];

const Container = styled(Flex)`
  background: #161930;
  border-radius: 8px;
  padding: 80px 5%;
  margin: auto;
  max-width: 1200px;
`;

const Card = styled(Flex)`
  border: 1px dashed #414568;
  border-radius: 8px;
  transition: 0.2s ease;
  &:hover {
    border: 1px solid #fff;
  }
`;

const Grid = styled.div`
  padding: 20px;
  align-items: center;
  justify-content: center;
  display: grid;
  width: 100%;
  max-width: 1200px;
  grid-template-columns: repeat(auto-fit, minmax(200px, 300px));
  grid-gap: 20px;
`;

const Site = ({ icon, name }) => (
  <Card w="100%" h="150px" align="center" justify="center">
    <img style={{ maxWidth: '90%' }} src={icon} alt={name} />
  </Card>
);

const Sitelist = () => (
  <Container id="sitelist" dir="column" minw="unset" w="90%" align="center">
    <Zoom>
      <Text.Heading center size="36">
        Supporting a wide range of <span style={{ color: '#2B98FB' }}>sites</span>
      </Text.Heading>
    </Zoom>
    <Flex h="75px" />
    <Grid>
      {sites.map(site => (
        <Zoom>
          <Site key={site.name} {...site} />
        </Zoom>
      ))}
    </Grid>
  </Container>
);

export default Sitelist;
